const states = {
  INITIAL: 0,
  LOADING: 1,
  DONE_SUCCESS: 2,
  DONE_FAILED: 3
};

export = states;
